export default (state = [], action = {}) => {
  switch(action.type) {
    case 'FETCH_EMPLS':
      return action.payload
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/empls.js